import { get_reviews2 } from '$lib/utils/get_reviews2';

/** @type {import('./$types').PageLoad} */
export async function load({ parent, data }) {
    const { supabase, worksheet } = await parent();

    const reviews = await get_reviews2({
        product_id: worksheet.id,
        supabase
    });

    return { ...data, reviews };
}


